module.exports = __webpack_public_path__ + "new-reviews.svg?925dfcb8ff62e98f7fa9ee03a33ae734";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-reviews.svg
// module id = 299
// module chunks = 2